import { giphyDarkestGrey, giphyLightestGrey } from '@giphy/colors'
import { ReactNode } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../constants'

const HitZone = styled.div`
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
`

const PopUp = styled.div`
    left: 0;
    line-height: 0;
    padding-top: 6px;
    position: absolute;
    top: 100%;
    transition: opacity 0.2s ease-out;
    width: 100%;
    z-index: 11;
`

const Arrow = styled.div`
    border-bottom: 8px solid ${giphyDarkestGrey};
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    display: inline-block;
    height: 0;
    margin: 0 9px;
    position: relative;
    width: 0;
    z-index: 1;
`

const Bubble = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: ${BORDER_RADIUS_SMALL}px;
    box-shadow: 0 2px 34px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    left: 50%;
    line-height: 1;
    min-width: 100%;
    padding: 20px;
    position: absolute;
    text-align: left;
    top: 100%;
    transform: translateX(-50%);
`

type Props = {
    children?: ReactNode
    className?: string
    backgroundColor?: string
    arrowPosition?: 'center' | 'left' | 'right'
    onClose: () => void
}

const CreationToolsPopUp = ({
    children,
    className,
    arrowPosition = 'center',
    backgroundColor = giphyDarkestGrey,
    onClose,
}: Props) => {
    return (
        <>
            <HitZone onClick={onClose} />
            <PopUp className={className} style={{ textAlign: arrowPosition }}>
                <Arrow style={{ borderBottomColor: backgroundColor }} />
                <Bubble style={{ backgroundColor }}>{children}</Bubble>
            </PopUp>
        </>
    )
}

export default CreationToolsPopUp
